import React, { useState } from 'react'

import Modal from 'react-bootstrap/Modal'
import Stack from 'react-bootstrap/Stack'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'

import { Spinner } from '../../LoadingContainer/Spinner'

export default function Delete({
  entity,
  text,
  showText = true,
  handleDelete,
  id,
  onClose,
  requireTypeToConfirm = false,
}) {
  const [isRemoving, setIsRemoving] = useState(false)

  const [confirmText, setConfirmText] = useState('')

  const matchesConfirmText = (val) => {
    return typeof val === 'string' && val.trim().toLowerCase() === 'delete'
  }

  const onDelete = () => {
    setIsRemoving(true)
    handleDelete(id)
      .then((res) => {
        if (!isRemoving) onClose()
      })
      .catch((err) => {
        console.error(err)
      })
      .finally(() => setIsRemoving(false))
  }

  return (
    <Modal.Body>
      <div className="modal-body-heading">
        <h1 className="modal-body-heading-title">
          Are you sure you want to delete this {entity}?
        </h1>
        {text && <p>{text}</p>}
        {showText && <p>You will not be able to restore this action</p>}
      </div>
      {requireTypeToConfirm && (
        <Form.Group className="mb-4" controlId="verification">
          <Form.Label className="form-label-sm form-label--lowercase-reset">
            To confirm deletion, type "delete" below:
          </Form.Label>
          <Form.Control
            type="text"
            value={confirmText}
            onChange={(e) => setConfirmText(e.target.value)}
            autoFocus
            autoComplete="off"
          />
        </Form.Group>
      )}
      <Stack
        direction={`${requireTypeToConfirm ? 'horizontal' : 'vertical'}`}
        className={`btn-group-flex ${requireTypeToConfirm ? 'jusify-content-end' : ''}`}
      >
        <Button
          variant="outline-light"
          size="lg"
          className={`btn-width text-danger ${requireTypeToConfirm ? 'btn-width-xs' : ''}`}
          onClick={onDelete}
          disabled={
            isRemoving ||
            (requireTypeToConfirm && !matchesConfirmText(confirmText))
          }
        >
          {isRemoving ? <Spinner variant="dark" /> : 'Delete'}
        </Button>
        <Button size="lg" onClick={onClose}>
          Cancel
        </Button>
      </Stack>
    </Modal.Body>
  )
}
